var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 7.10994L8.28796 11.822C7.63736 12.4726 6.58253 12.4726 5.93193 11.822L1.21987 7.10994C-0.406624 5.48344 -0.406624 2.84637 1.21987 1.21987C2.84637 -0.406624 5.48344 -0.406624 7.10994 1.21987C8.73644 -0.406624 11.3735 -0.406624 13 1.21987C14.6265 2.84637 14.6265 5.48344 13 7.10994Z",
    fill: "#D79999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductHeart);
export default __webpack_public_path__ + "static/media/product-heart.bd2b04b86a4adaa50808b6be6d9d275d.svg";
export { ForwardRef as ReactComponent };